import React from "react";
import { Button, Dropdown } from "semantic-ui-react";

class SettingsButton extends React.Component {
  state = {
    open: false,
  };

  render() {
    return (
      <Dropdown
        fluid
        open={this.state.open}
        icon={null}
        trigger={
          <Button
            icon="settings"
            color="blue"
            disabled={this.props.disabled}
            direction="left"
            onClick={() => this.setState({ open: !this.state.open })}
          />
        }
      >
        <Dropdown.Menu fluid>
          <Dropdown.Item>{this.props.children}</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default SettingsButton;
